import React, {useEffect, useState} from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import '../../styles/SuccessScreen.css';
import '../../styles/Subscribed.css';
import { HiGlobeAmericas } from "react-icons/hi2"; 

const baseUrl = process.env.REACT_APP_API_URL;

const SuccessScreen = () => {
    const { user, login, setUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [verifying, setVerifying] = useState(true);
    
    useEffect(() => {
        const verifySubscription = async () => {
            try {
                const searchParams = new URLSearchParams(location.search);
                const sessionId = searchParams.get('session_id');
                
                if (sessionId) {
                    // Verify the session with the backend
                    const response = await fetch(`${baseUrl}/api/verify-session`, {
                        method: 'POST',
                        body: JSON.stringify({ 
                            email: user?.email,
                            session_id: sessionId 
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    
                    if (response.ok) {
                        const data = await response.json();
                        // Update user with subscription data
                        if (data.user) {
                            setUser({...user, ...data.user});
                        }
                    }
                }
            } catch (error) {
                console.error("Error verifying subscription:", error);
            } finally {
                setVerifying(false);
            }
        };
        
        if (user?.email) {
            verifySubscription();
        }
    }, [user?.email, location.search]);

    const handleReturnToProfile = () => {
        navigate('/profile');
    }

    return (
        <div className="flex flex-col min-h-screen w-full bg-gradient-to-br from-white/30 to-uranian-blue/20 backdrop-blur-sm" style={{ backgroundImage: "url('/images/leelo_landing.jpg')" }}>
            <div className="w-full max-w-7xl mx-auto p-5 flex flex-col items-center justify-center">
                <header className="flex justify-end items-center mb-5 px-5 w-full">
                    <div className="flex items-center gap-7">
                        <span className="flex items-center gap-2 text-white">
                            {user?.city}, {user?.state} <HiGlobeAmericas className="text-lg" />
                        </span>
                        <button 
                            onClick={handleReturnToProfile} 
                            className="flex items-center gap-1 font-bold text-white hover:text-tropical-indigo cursor-pointer"
                        >
                            Return to Profile
                        </button>
                    </div>
                </header>
                
                <main className="flex-grow bg-gradient-to-br from-white/95 to-uranian-blue/80 backdrop-blur-sm shadow-xl rounded-lg py-16 px-12 w-full max-w-2xl mx-auto border border-white/20">
                    {verifying ? (
                        <div className="subscribed-container flex flex-col justify-center items-center">
                            <h1 className="centered-buttons text-center text-3xl font-bold mb-4">Verifying Your Subscription...</h1>
                            <h2 className="centered-buttons text-center mb-8 text-gray-700">Please wait while we confirm your payment.</h2>
                            <div className="y-4 mb-6">
                                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
                            </div>
                        </div>
                    ) : (
                        <div className="subscribed-container flex flex-col justify-center items-center">
                            <h1 className="centered-buttons text-center text-3xl font-bold mb-4">Success!</h1>
                            <h2 className="centered-buttons text-center mb-8 text-gray-700">
                                {user?.subscription_status === 'active' 
                                    ? 'Your subscription is now active! Start chatting with your AI thought partner now.'
                                    : 'Start chatting with your AI thought partner now.'}
                            </h2>
                            
                            <div className="y-4 mb-6"> 
                                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                    <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                </svg>
                            </div>
                            
                            <div className="account-button-container flex items-center justify-center gap-4">
                                <Link to="/profile" className="flex items-center justify-center gap-2 bg-white text-black border border-black hover:text-tropical-indigo hover:border-tropical-indigo rounded px-5 py-3 text-base cursor-pointer">Go to Profile</Link>
                            </div>
                        </div>
                    )}
                </main>
                
                <footer className="flex justify-between items-center py-6 px-8 w-full max-w-2xl mx-auto">
                    <p className="text-xs text-white m-0 flex items-center">
                        2025 © Wenzi, Inc. 
                        <span className="mx-2">•</span> 
                        <Link to="/privacy" className="text-white hover:underline">Privacy Policy</Link>
                        <span className="mx-2">•</span> 
                        <a href="https://discord.gg/z859AyVU3R" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Join our Discord</a>
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default SuccessScreen;